module.exports = __webpack_public_path__ + "img/vegetable-yams-350x184.6b4a3fff.jpg";